module.exports = __webpack_public_path__ + "static/media/check.ef30add0.svg";